export default __webpack_public_path__ + "72fd4d02c7d00eba361a761e200ad10e.svg";